import axios from 'axios';
import Cookies from 'js-cookie';

export default async function getProducts() {
  try {
    const sessionToken = Cookies.get('next-auth.session-token');
    const csrfToken = Cookies.get('next-auth.csrf-token');

    const response = await axios.get('/api/orders', {
      headers: {
        'Cookie': `next-auth.session-token=${sessionToken}; next-auth.csrf-token=${csrfToken}`
      }
    });

    return response.data; // Assuming response.data contains the orders data
  } catch (error) {
    console.error('Failed to fetch orders:', error.response?.data || error.message);
    return { error: error.response?.data || error.message }; // Return an error object
  }
}
